// KL - female personal trainer (incl. muslimah-friendly). No trainer list.
const content = {
    slug: 'female-personal-trainer',
    title: 'Female Personal Trainer in KL | Muslimah-Friendly Sessions',
    description: (c) =>
        `Female personal trainers in Kuala Lumpur, including muslimah-friendly sessions at home or in women-only spaces. From ${c.money(c.lowest + c.mods.female, 0)} a session.`,
    eyebrow: 'KL · Female trainer',
    h1: 'Female Personal Trainer in Kuala Lumpur',
    lead: 'Train with a woman coach at home, in your condo gym or in a women-only space - including muslimah-friendly sessions that respect aurat and privacy.',
    image: 'personal-trainer/female-personal-trainer-training-girl-at-gym-hd.jpeg',
    imageAlt: 'Female trainer coaching a woman in a gym',
    facts: ['Female trainers only', 'Muslimah-friendly', 'Home or condo gym'],
    ctaLabel: 'Request a female trainer',
    matchSummary: 'a female personal trainer in KL',
    packagesTitle: 'Packages with a female trainer',
    packagesHighlight: (c) => `A female trainer preference adds ${c.money(c.mods.female, 0)} a session - for example ${c.money(c.pt('Signature', 30) + c.mods.female, 0)} a session on the 30-session Signature package.`,
    sections: [
        {
            title: 'Muslimah-friendly training',
            cards: [
                { title: 'Private setting', body: 'Sessions at home or in a women-only room, with no men present.' },
                { title: 'Comfortable attire', body: 'Training in your hijab and modest sportswear; exercises chosen to suit.' },
                { title: 'Around prayer times', body: 'Sessions scheduled around solat, and adjusted during Ramadan.' },
            ],
        },
        {
            title: 'Popular goals',
            tone: 'muted',
            items: [
                'Toning and strength for everyday life.',
                'Weight loss after pregnancy or after a stressful year.',
                'Strength to prevent back and knee pain.',
                'Confidence in the gym before joining one.',
                'Training with a sister, friend or mother on the partner rate.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can I request a female personal trainer in KL?',
            answer: 'Yes. Choose a female trainer preference when you request a match.',
        },
        {
            question: 'Can I train wearing hijab?',
            answer: 'Of course. Your trainer chooses exercises and gear that suit modest sportswear.',
        },
        {
            question: 'Is a female trainer more expensive?',
            answer: (c) => `Yes, by ${c.money(c.mods.female, 0)} a session.`,
        },
    ],
    schema: { name: 'Female Personal Trainer in Kuala Lumpur' },
}

export default content
